import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { push } from 'react-router-redux';

import { customerList } from '../../actions/company';
import NotFound from '../../components/NotFound';
import NavBarConfig from '../../components/NavBarConfig';
import CustomerList from './components/CustomerList';

const messages = defineMessages({
  CREATE_CUSTOMER: {
    id: 'CustomerListPage.CREATE_CUSTOMER',
    defaultMessage: 'Kunde anlegen',
  },
  ADJUST_PROFILE: {
    id: 'CustomerListPage.ADJUST_PROFILE',
    defaultMessage: 'Profil anpassen',
  },
  MAINTAIN_USER: {
    id: 'CustomerListPage.MAINTAIN_USER',
    defaultMessage: 'Benutzer verwalten',
  },
  MAINTAIN_ACCOUNT: {
    id: 'CustomerListPage.MAINTAIN_ACCOUNT',
    defaultMessage: 'Nutzerkonto verwalten',
  },
  DELETE_COMPANY: {
    id: 'CustomerListPage.DELETE_COMPANY',
    defaultMessage: 'Unternehmen löschen',
  },
  APPLY_CUSTOMER: {
    id: 'CustomerListPage.APPLY_CUSTOMER',
    defaultMessage: 'Oben rechts können Sie einen ersten Kunden anlegen.',
  },
  BILLINGS: {
    id: 'CustomerListPage.BILLINGS',
    defaultMessage: 'Einzelverbindungsnachweise',
  },
  MORE_OPTIONS: {
    id: 'CustomerListPage.MORE_OPTIONS',
    defaultMessage: 'Weitere Optionen',
  },
  QUOTA_WARNING_TITLE: {
    id: 'CustomerListPage.QUOTA_WARNING_TITLE',
    defaultMessage: 'Achtung: Kontingent fast aufgebraucht',
  },
  QUOTA_WARNING_TEXT: {
    id: 'CustomerListPage.QUOTA_WARNING_TEXT',
    defaultMessage: 'Ihr aktuelles Paket (Calls/Minuten) ist zu mindestens 80% aufgebraucht.',
  },
  ADD_PACKAGE: {
    id: 'CustomerListPage.ADD_PACKAGE',
    defaultMessage: 'Paket hinzubuchen',
  },
  SEARCH: {
    id: 'CustomerListPage.SEARCH',
    defaultMessage: 'Suchen...',
  },
});

class CustomerListPageComponent extends React.Component {
  componentWillMount() {
    this.props.load();

    let initFilter = '';
    if (this.props.filter){
      initFilter = this.props.filter;
    }


    this.setState({
      results: null,
      filter: initFilter
    });
    this.handleOnChangeSearch = this.handleOnChangeSearch.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.companyId !== nextProps.params.companyId) {
      nextProps.load();
    }
  }

  handleOnChangeSearch(event) {
    this.setState({
      filter: event.target.value
    });
    this.props.search(event.target.value);
  }

  render() {
    const {
      user,
      company,
      companyMembership,
      error,
      results,
      filteredResults,
      intl: { formatMessage },
    } = this.props;

    if (!company || !companyMembership) {
      return null;
    }
    if (error) {
      return <NotFound />;
    }
    const canAdmin = user.is_admin || companyMembership.is_admin;
    const isOwner = companyMembership.is_owner;
    
    return (
      <div style={{ padding: '16px', backgroundColor: 'transparent', minHeight: '100vh', width: '100%' }}>
        <NavBarConfig
          customerList={{ company_id: company.id }}
          currentRouteName={
            this.props.routes[this.props.routes.length - 1].name
          }
        />
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          {company.active_subscription && company.active_subscription.quota_warning && (
            <div style={{ padding: '16px', backgroundColor: '#fff7ed', borderLeft: '4px solid #f97316', borderRadius: '8px', marginBottom: '24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <i className="fa fa-exclamation-triangle" style={{ color: '#f97316', fontSize: '20px' }} />
                <div>
                  <h4 style={{ margin: '0 0 4px 0', color: '#9a3412', fontWeight: 'bold' }}>{formatMessage(messages.QUOTA_WARNING_TITLE)}</h4>
                  <p style={{ margin: 0, color: '#c2410c', fontSize: '14px' }}>{formatMessage(messages.QUOTA_WARNING_TEXT)}</p>
                </div>
              </div>
              <button 
                onClick={() => this.props.navigate(`/company/${company.id}/billing`)}
                style={{ padding: '8px 16px', backgroundColor: '#f97316', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}
              >
                {formatMessage(messages.ADD_PACKAGE)}
              </button>
            </div>
          )}
          
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '16px' }}>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: 'var(--panel-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', fontSize: '18px', border: '1px solid var(--panel-border)' }}>
                <i className="fa fa-building" />
              </div>
              {company.name}
            </h2>
            
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'nowrap' }}>
              <div style={{ position: 'relative', flex: '1 1 auto', minWidth: '120px' }}>
                <i className="fa fa-search" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
                <input
                  style={{ padding: '0 12px 0 32px', height: '38px', boxSizing: 'border-box', borderRadius: '8px', border: '1px solid var(--input-border)', backgroundColor: 'var(--input-bg)', color: 'var(--input-text)', outline: 'none', width: '100%', maxWidth: '250px', fontSize: '14px' }}
                  type="text"
                  placeholder={formatMessage(messages.SEARCH)}
                  value={this.state.filter}
                  onChange={this.handleOnChangeSearch}
                />
              </div>

              <Link
                className="lh-btn lh-btn-primary"
                to={`/company/${company.id}/customer/create/`}
                style={{ height: '38px', boxSizing: 'border-box', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap' }}
              >
                <i className="fa fa-plus" /> {formatMessage(messages.CREATE_CUSTOMER)}
              </Link>
            </div>
          </div>

          <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '12px', boxShadow: '0 4px 6px -1px var(--panel-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
            {filteredResults
              ? <CustomerList items={filteredResults} filter={this.state.filter} allItems={results} company={company} />
              : <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-muted)' }}>{formatMessage(messages.APPLY_CUSTOMER)}</div>}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => state.customerList,
  (dispatch, props) => ({
    load: () => dispatch(customerList.load(props.params.companyId)),
    navigate: url => dispatch(push(url)),
    search: (search) => dispatch(customerList.search(search))
  })
)(injectIntl(CustomerListPageComponent));
